
    import { defineComponent } from 'vue';
    import InputCommon from '@ve/components/inputs/InputCommon.vue';
    import ButtonCommon from '@ve/components/button/desktop/Button.vue';
    import useBudgetFilter from '../common/use/useBudgetFilter';

    export default defineComponent({
        components: {
            InputCommon,
            ButtonCommon,
        },
        setup() {
            return {
                ...useBudgetFilter(),
            };
        },
    });
